export default __webpack_public_path__ + "static/media/childfashion.ace087f5.webp";